import React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import ChecklistIcon from "@mui/icons-material/Checklist";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import HistoryIcon from "@mui/icons-material/History";
import { ReactComponent as DroneIcon } from "@src/assets/icons/drones.svg";
import { ReactComponent as FleetIcon } from "@src/assets/icons/fleet.svg";
import { ReactComponent as FleetActiveIcon } from "@src/assets/icons/fleet-active.svg";
import { ReactComponent as OrdersIcon } from "@src/assets/icons/orders.svg";
import { ReactComponent as ZonesIcon } from "@src/assets/icons/zone.svg";
import { ReactComponent as ZonesActiveIcon } from "@src/assets/icons/zone-active.svg";
import { ReactComponent as AnalyticsActiveIcon } from "@src/assets/icons/analytics-active.svg";
import { ReactComponent as AnalyticsIcon } from "@src/assets/icons/analytics.svg";
import { NavLinkEntity } from '@src/layouts/root-layout/entities';
import { routesConfig } from "@src/core/routes";
import { UserRoleType } from "@src/core/features";

export const rootLinks: NavLinkEntity[] = [
  {
    id: 1,
    name: "Orders",
    path: routesConfig.orders,
    exact: [
      routesConfig.orders,
      routesConfig.createOrder,
      routesConfig.assignDrone,
      `${routesConfig.createMission}/:id`,
      `${routesConfig.confirmOrder}/:id`,
      `${routesConfig.checklistOrder}/:id`,
    ],
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OPERATOR, UserRoleType.OWNER],
    icon: <OrdersIcon width={18} />,
    activeIcon: <OrdersIcon width={18} stroke="#9E9EF3" />,
  },
  {
    id: 2,
    name: "Drones",
    path: routesConfig.drones,
    exact: [routesConfig.drones],
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OPERATOR, UserRoleType.OWNER],
    icon: <DroneIcon width={18} />,
    activeIcon: <DroneIcon width={18} stroke="#9E9EF3" />,
  },
  {
    id: 3,
    name: "Check",
    path: routesConfig.checklist,
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OPERATOR, UserRoleType.OWNER],
    exact: [routesConfig.checklist],
    icon: <ChecklistIcon sx={{ color: "text.secondary", fontSize: 18 }} />,
    activeIcon: <ChecklistIcon sx={{ color: "brand.main", fontSize: 18 }} />,
  },
  {
    id: 4,
    name: "Zones",
    path: routesConfig.zones,
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OPERATOR, UserRoleType.OWNER],
    exact: [routesConfig.zones, routesConfig.createZone, routesConfig.editZone, `${routesConfig.editZone}/:id`, routesConfig.createSafeLandZone],
    icon: <ZonesIcon width={18} />,
    activeIcon: <ZonesActiveIcon width={18}/>,
  },
  {
    id: 6,
    name: "Fleet",
    path: routesConfig.fleet,
    exact: [routesConfig.fleet, routesConfig.addDrone],
    roles: [
      UserRoleType.ADMIN,
      UserRoleType.SUPERADMIN,
      UserRoleType.OPERATOR,
      UserRoleType.OWNER,
      UserRoleType.ANALYST,
    ],
    icon: <FleetIcon width={18} />,
    activeIcon: <FleetActiveIcon width={18} />,
  },
  {
    id: 7,
    name: "History",
    path: routesConfig.history,
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OPERATOR, UserRoleType.OWNER],
    exact: [routesConfig.history],
    icon: <HistoryIcon sx={{ color: "text.secondary", fontSize: 18 }} />,
    activeIcon: <HistoryIcon sx={{ color: "brand.main", fontSize: 18 }} />,
  },
  {
    id: 8,
    name: "Analytics",
    path: routesConfig.analytics,
    roles: [
      UserRoleType.ADMIN,
      UserRoleType.SUPERADMIN,
      UserRoleType.OWNER,
      UserRoleType.ANALYST,
    ],
    exact: [routesConfig.analytics],
    icon: <AnalyticsIcon width={18} />,
    activeIcon: <AnalyticsActiveIcon width={18} />,
  },
  {
    id: 9,
    name: 'Settings',
    path: routesConfig.settings,
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OWNER],
    exact: [routesConfig.settings],
    icon: <SettingsIcon sx={{ color: 'text.secondary', fontSize: 18 }} />,
    activeIcon: <SettingsIcon sx={{ color: 'brand.main', fontSize: 18 }} />,
  },
  {
    id: 10,
    name: "Api",
    path: routesConfig.integration,
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.OWNER],
    exact: [routesConfig.integration],
    icon: <AspectRatioIcon sx={{ color: "text.secondary", fontSize: 18 }} />,
    activeIcon: <AspectRatioIcon sx={{ color: "brand.main", fontSize: 18 }} />,
  },
  {
    id: 11,
    name: "Viewer",
    path: routesConfig.viewer,
    roles: [UserRoleType.ADMIN, UserRoleType.SUPERADMIN, UserRoleType.VIEWER, UserRoleType.OWNER],
    exact: [routesConfig.viewer],
    icon: <LocalSeeIcon sx={{ color: "text.secondary", fontSize: 18 }} />,
    activeIcon: <LocalSeeIcon sx={{ color: "brand.main", fontSize: 18 }} />,
  },
];
